import * as React from 'react';
import { ReactNode, useContext } from 'react';
import { SolrWorkReduced, WorkApi } from '../../../api/core';
import { NavigateFunction, useNavigate } from 'react-router';
import { ParsedMathJax } from '../../components/ParsedMathJax';
import { authorsPreviewWorkResult } from '../../../Settings/config';
import { IntlShape, useIntl } from 'react-intl';
import { Button } from 'primereact/button';
import { AuthContext } from '../../../Auth/components/AuthProvider';
import { SearchResult, SearchResultHeader } from './SearchResult';
import { deleteWork, requestDeleteWork } from '../../../util/actions/work-actions';
import { ToastContext, ToastContextType } from '../../../util/providers/ToastProvider';
import { getAuthMiddleware } from '../../../Auth/utils/GetAuthMiddleware';
import { BreakingList } from '../../detail/components/layout/BreakingList';
import { QuoteIcon } from '../../components/QuoteIcon';


export interface SearchResultWorkProps {
  key: number;
  position: number;
  result: SolrWorkReduced;
  showCitation: () => void;
  redirectPath?: string;
}

export function SearchResultWork(props: SearchResultWorkProps): ReactNode {
  const intl: IntlShape = useIntl();
  const toast: ToastContextType = useContext(ToastContext);
  const {actions} = useContext(AuthContext);
  const navigate: NavigateFunction = useNavigate();
  const workApi: WorkApi = new WorkApi().withMiddleware(getAuthMiddleware(actions));

  const {result} = props;

  const header: SearchResultHeader = {
    label: result.subseriesTitle ? `${result.mainTitle} / ${result.subseriesTitle}` : result.mainTitle,
    url: `/work/${result.id}`,
  };

  const footer: ReactNode = <Button
    icon={<QuoteIcon/>}
    onClick={(): void => props.showCitation()}
    outlined={true}
    tooltip={intl.formatMessage({id: 'button.cite'})}
    tooltipOptions={{position: 'bottom'}}
  />;

  const contents: ReactNode[] = [];
  if (result.issued) {
    contents.push(<>({result.issued})</>);
  }
  if (result.subTitle) {
    contents.push(<ParsedMathJax content={result.subTitle} />);
  }
  if (result.personName && result.personName.length > 0) {
    contents.push(
      <BreakingList limits={authorsPreviewWorkResult} separator={';'}>
        {result.personName}
      </BreakingList>,
    );
  }

  return <SearchResult
    position={props.position}
    header={header}
    footer={footer}
    contents={contents}
    result={result}
    editUrl={`/work/${result.id}/edit`}
    delete={(): void => deleteWork(workApi, toast, intl, navigate, parseInt(result.id, 10), result.mainTitle, props.redirectPath)}
    requestDelete={(): void => requestDeleteWork(workApi, toast, intl, navigate, parseInt(result.id, 10), result.mainTitle, props.redirectPath)}
  />;
}
